import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fd9b4dc6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "img-container" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["alt", "src"]
const _hoisted_4 = { id: "img-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: _ctx.registryLinkPath,
      target: "_blank"
    }, [
      _createElementVNode("img", {
        alt: _ctx.imageDescription,
        src: require(`@/assets/${_ctx.imageFileName}`),
        width: "200"
      }, null, 8, _hoisted_3),
      _createElementVNode("p", _hoisted_4, " View Regina and Dan's '" + _toDisplayString(_ctx.registryGoalName) + "' goal on Zola.com ", 1)
    ], 8, _hoisted_2)
  ]))
}